import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UserFormService } from './user-form.service';

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss']
})
export class UserFormComponent implements OnInit {
   fieldArray: Array<any> = [];
   newAttribute: any = {};
   fieldList: Array<any> = [];
   newList:any = {};
   DragData: any;
  values: any;
  tempData: any;
  sectionOneData: Object;
  sectionTWOdata: any;
  sectionThreeData: any;
  sectionFourdata: any;
  sectionFiveData: any;
  sectionSixdata: any;
  sectionSevenData: any;
  sectionEightdata: any;
  sectionNinthdata: any;
  tempADDdata: any;
  tempDELETEdata: any;
  tempListdata: Object;
  deleteListdata: Object;
  tempEDITdata: any;
  tempdata2: any;
  tempdata3: any;
  tempdata4: any;
  tempdata5: any;
  tempdata6: any;
  tempdata7: any;
  tempdata8: any;
  tempdata9: any;

  constructor(private userFormService: UserFormService,
    // private directoryservice: DataDirectoryService,
    public toastr: ToastrService) {
    // this.directoryservice.serchKey = '';
   }

  ngOnInit(): void {
    this.getUserFormTemplate();
    this.getBackendUserform();
  }

  getUserFormTemplate(){
      this.userFormService.getUserForm().subscribe((res)=>{
        this.sectionOneData = this.tempData = res["First"]["INNOVATOR/BRAND PRODUCT DETAILS"];
        this.sectionTWOdata = this.tempdata2 = res["Second"]["PATENT INFORMATION"];          
        this.sectionThreeData = this.tempdata3 = res["Third"]["REGULATORY INFORMATION"];
        this.sectionFourdata = this.tempdata4 = res["Fourth"]["CLINICAL INFORMATION"];
        this.sectionFiveData = this.tempdata5 = res["Fifth"]["API INFORMATION"];
        this.sectionSixdata = this.tempdata6 = res["Sixth"]["FORMULATION INFORMATION"];
        this.sectionSevenData = this.tempdata7 = res["Seventh"]["COMPETITIVE INTELLIGENCE"];
        this.sectionEightdata = this.tempdata8 = res["Eighth"]["Executive SUMMARY"];
        this.sectionNinthdata = this.tempdata9 = res["Ninth"]["COSTING RELATED"];
      })
  }

  getBackendUserform(){
    this.userFormService.getBackendUserForm().subscribe((res)=>{
      // this.tempData = res["data"];

    })
  }

  editdata(section,event, arr, keys, trows, rd, Obj, index, varikey, n9, n10) {

    // console.log("event.target.value-", event.target.value,"event-",event,"arr-", arr, "keys-", keys, "trows-", trows, "rd-", rd, "obj-", Obj, "index-", index, "varikey-", varikey, "n9-", n9, "n10-", n10, "section-", section)
    if(section === "sectionOne"){
      this.tempEDITdata = this.tempData;
    }
    if(section === "sectionTwo"){
      this.tempEDITdata = this.tempdata2
    }
    if(section === "sectionThree"){
      this.tempEDITdata = this.tempdata3
    }
    if(section === "sectionFour"){
      this.tempEDITdata = this.tempdata4
    }
    if(section === "sectionFive"){
      this.tempEDITdata = this.tempdata5
    }
    if(section === "sectionSix"){
      this.tempEDITdata = this.tempdata6
    }
    if(section === "sectionSeven"){
      this.tempEDITdata = this.tempdata7
    }
    if(section === "sectionEight"){
      this.tempEDITdata = this.tempdata8
    }
    if(section === "sectionNine"){
      this.tempEDITdata = this.tempdata9
    }
   
    if (Obj !== undefined) {
      if (this.tempEDITdata[keys] && Obj.value) {
        this.tempEDITdata[keys].map((res, j) => {
          Obj.value.map((resp, j1) => {
            if (j === index && j === j1) {
              let objkey = Object.keys(Obj.value[0]);
              let uniquekey = objkey[n10]
              resp[uniquekey] = event.target.value;
            }
          })
        })        
      }
    } 
    if (Obj === 'lItems') {
      if (Array.isArray(this.tempEDITdata[keys])) {
        this.tempEDITdata[keys].map((respp, k) => {
          if (arr) {
            arr.map((resps, p) => {
              if (p === rd) {
                if (resps === trows) {
                  arr[rd] = event.target.value;
                }
              }
            })
          } else { }
        })
      }
    } else if (Obj === undefined) {
      this.tempEDITdata[keys] = event.target.value;
    }
    
    if(section === "sectionOne"){
      this.tempData = this.sectionOneData  = this.tempEDITdata;
    }
    if(section === "sectionTwo"){
      this.tempdata2 = this.sectionTWOdata = this.tempEDITdata;
    }
    if(section === "sectionThree"){
      this.tempdata3 = this.sectionThreeData = this.tempEDITdata;
    }
    if(section === "sectionFour"){
      this.tempdata4 = this.sectionFourdata = this.tempEDITdata;
    }
    if(section === "sectionFive"){
      this.tempdata5 = this.sectionFiveData = this.tempEDITdata;
    }
    if(section === "sectionSix"){
      this.tempdata6 = this.sectionSixdata = this.tempEDITdata;
    }
    if(section === "sectionSeven"){
      this.tempdata7 = this.sectionSevenData = this.tempEDITdata;
    }
    if(section === "sectionEight"){
      this.tempdata8 = this.sectionEightdata = this.tempEDITdata;
    }
    if(section === "sectionNine"){
      this.tempdata9 = this.sectionNinthdata = this.tempEDITdata;
    }  
    
  }


  addListItem(data,n4, n5, n6, n7, section){
    if(section === "sectionOne"){
      this.tempListdata = this.sectionOneData;
    }
    if(section === "sectionTwo"){
      this.tempListdata = this.sectionTWOdata
    }
    if(section === "sectionThree"){
      this.tempListdata = this.sectionThreeData
    }
    if(section === "sectionFour"){
      this.tempListdata = this.sectionFourdata
    }
    if(section === "sectionFive"){
      this.tempListdata = this.sectionFiveData
    }
    if(section === "sectionSix"){
      this.tempListdata = this.sectionSixdata
    }
    if(section === "sectionSeven"){
      this.tempListdata = this.sectionSevenData
    }
    if(section === "sectionEight"){
      this.tempListdata = this.sectionEightdata
    }
    if(section === "sectionNine"){
      this.tempListdata = this.sectionNinthdata
    }

    let objdata: any = this.tempListdata;
      let arr = [];
      console.log("Arrayyyy", objdata[n7].push(arr));
      this.tempListdata = { ...objdata };

      if(section === "sectionOne"){
        this.sectionOneData = this.tempListdata;
      }
      if(section === "sectionTwo"){
        this.sectionTWOdata = this.tempListdata;
      }
      if(section === "sectionThree"){
        this.sectionThreeData = this.tempListdata;
      }
      if(section === "sectionFour"){
        this.sectionFourdata = this.tempListdata;
      }
      if(section === "sectionFive"){
        this.sectionFiveData = this.tempListdata;
      }
      if(section === "sectionSix"){
        this.sectionSixdata = this.tempListdata;
      }
      if(section === "sectionSeven"){
        this.sectionSevenData = this.tempListdata;
      }
      if(section === "sectionEight"){
        this.sectionEightdata = this.tempListdata;
      }
      if(section === "sectionNine"){
        this.sectionNinthdata = this.tempListdata;
      }    
  }

  deleteListItem(data, n7, section){
    if(data.length < 2){
      this.toastr.error('Cannnot be deleted', '');
    }
    else{
      if(section === "sectionOne"){
        this.deleteListdata = this.sectionOneData;
      }
      if(section === "sectionTwo"){
        this.deleteListdata = this.sectionTWOdata
      }
      if(section === "sectionThree"){
        this.deleteListdata = this.sectionThreeData
      }
      if(section === "sectionFour"){
        this.deleteListdata = this.sectionFourdata
      }
      if(section === "sectionFive"){
        this.deleteListdata = this.sectionFiveData
      }
      if(section === "sectionSix"){
        this.deleteListdata = this.sectionSixdata
      }
      if(section === "sectionSeven"){
        this.deleteListdata = this.sectionSevenData
      }
      if(section === "sectionEight"){
        this.deleteListdata = this.sectionEightdata
      }
      if(section === "sectionNine"){
        this.deleteListdata = this.sectionNinthdata
      }

      let objdata: any = this.deleteListdata;
      let arr = [];
      console.log("Arrayyyy", objdata[n7].pop());
      this.deleteListdata = { ...objdata };

      if(section === "sectionOne"){
        this.sectionOneData = this.deleteListdata;
      }
      if(section === "sectionTwo"){
        this.sectionTWOdata = this.deleteListdata;
      }
      if(section === "sectionThree"){
        this.sectionThreeData = this.deleteListdata;
      }
      if(section === "sectionFour"){
        this.sectionFourdata = this.deleteListdata;
      }
      if(section === "sectionFive"){
        this.sectionFiveData = this.deleteListdata;
      }
      if(section === "sectionSix"){
        this.sectionSixdata = this.deleteListdata;
      }
      if(section === "sectionSeven"){
        this.sectionSevenData = this.deleteListdata;
      }
      if(section === "sectionEight"){
        this.sectionEightdata = this.deleteListdata;
      }
      if(section === "sectionNine"){
        this.sectionNinthdata = this.deleteListdata;
      }
    }
  }

  addItems(data, n2, n3, n4, n5, n6, n7, section) {

    if(section === "sectionOne"){
      this.tempADDdata = this.sectionOneData;
    }
    if(section === "sectionTwo"){
      this.tempADDdata = this.sectionTWOdata
    }
    if(section === "sectionThree"){
      this.tempADDdata = this.sectionThreeData
    }
    if(section === "sectionFour"){
      this.tempADDdata = this.sectionFourdata
    }
    if(section === "sectionFive"){
      this.tempADDdata = this.sectionFiveData
    }
    if(section === "sectionSix"){
      this.tempADDdata = this.sectionSixdata
    }
    if(section === "sectionSeven"){
      this.tempADDdata = this.sectionSevenData
    }
    if(section === "sectionEight"){
      this.tempADDdata = this.sectionEightdata
    }
    if(section === "sectionNine"){
      this.tempADDdata = this.sectionNinthdata
    }

    let objdata: any = this.tempADDdata;
    let obj = {};
    let keys = Object.keys(data[0]);
    for (let i = 0; i <= keys.length - 1; i++) {
      obj[keys[i]] = '';
    }
    console.log("objjjj", obj);
    objdata[n7].push(obj);
    // console.log("objdata", objdata[n7])
    // console.log("Arrayyyy", objdata[n7].push(arr));
    this.tempADDdata = { ...objdata };
    // this.tempData = { ...objdata };
    console.log("final this.DragData", this.tempADDdata);

    if(section === "sectionOne"){
      this.sectionOneData = this.tempADDdata;
    }
    if(section === "sectionTwo"){
      this.sectionTWOdata = this.tempADDdata;
    }
    if(section === "sectionThree"){
      this.sectionThreeData = this.tempADDdata;
    }
    if(section === "sectionFour"){
      this.sectionFourdata = this.tempADDdata;
    }
    if(section === "sectionFive"){
      this.sectionFiveData = this.tempADDdata;
    }
    if(section === "sectionSix"){
      this.sectionSixdata = this.tempADDdata;
    }
    if(section === "sectionSeven"){
      this.sectionSevenData = this.tempADDdata;
    }
    if(section === "sectionEight"){
      this.sectionEightdata = this.tempADDdata;
    }
    if(section === "sectionNine"){
      this.sectionNinthdata = this.tempADDdata;
    }    
  }
  
  deleteItems(data, n7, section){
    if(data.length < 2){
      this.toastr.error('Cannnot be deleted', '');
    }
    else{
      if(section === "sectionOne"){
        this.tempDELETEdata = this.sectionOneData;
      }
      if(section === "sectionTwo"){
        this.tempDELETEdata = this.sectionTWOdata
      }
      if(section === "sectionThree"){
        this.tempDELETEdata = this.sectionThreeData
      }
      if(section === "sectionFour"){
        this.tempDELETEdata = this.sectionFourdata
      }
      if(section === "sectionFive"){
        this.tempDELETEdata = this.sectionFiveData
      }
      if(section === "sectionSix"){
        this.tempDELETEdata = this.sectionSixdata
      }
      if(section === "sectionSeven"){
        this.tempDELETEdata = this.sectionSevenData
      }
      if(section === "sectionEight"){
        this.tempDELETEdata = this.sectionEightdata
      }
      if(section === "sectionNine"){
        this.tempDELETEdata = this.sectionNinthdata
      }

      let objdata: any = this.tempDELETEdata;
      let obj = {};
      let keys = Object.keys(data[0]);
      for (let i = 0; i <= keys.length - 1; i++) {
        obj[keys[i]] = '';
      }
      console.log("objjjj", obj);
      objdata[n7].pop(obj);
      this.tempDELETEdata = { ...objdata };
      console.log("final data after pop", this.tempDELETEdata);

      if(section === "sectionOne"){
        this.sectionOneData = this.tempDELETEdata;
      }
      if(section === "sectionTwo"){
        this.sectionTWOdata = this.tempDELETEdata;
      }
      if(section === "sectionThree"){
        this.sectionThreeData = this.tempDELETEdata;
      }
      if(section === "sectionFour"){
        this.sectionFourdata = this.tempDELETEdata;
      }
      if(section === "sectionFive"){
        this.sectionFiveData = this.tempDELETEdata;
      }
      if(section === "sectionSix"){
        this.sectionSixdata = this.tempDELETEdata;
      }
      if(section === "sectionSeven"){
        this.sectionSevenData = this.tempDELETEdata;
      }
      if(section === "sectionEight"){
        this.sectionEightdata = this.tempDELETEdata;
      }
      if(section === "sectionNine"){
        this.sectionNinthdata = this.tempDELETEdata;
      }  
    }
    
  }

  saveEdit(){    
    let nda = this.tempData["NDA number"];
    let brandName = this.tempData["Brand Name/Proprietary Name"];
    let dosageForm = this.tempData["Dosage forms"];
    if( nda === ""){
      this.toastr.error('Please enter NDA number', 'INNOVATOR/BRAND PRODUCT DETAILS');
    }
    if( brandName === ""){
      this.toastr.error('Please enter Brand name', 'INNOVATOR/BRAND PRODUCT DETAILS');
    }
    if( dosageForm === ""){
      this.toastr.error('Please enter Dosage form', 'INNOVATOR/BRAND PRODUCT DETAILS');
    }
    if( nda !== "" && brandName !== "" && dosageForm !== ""){
      console.log("nda in save method", nda)
      let temp = [];
      temp.push(this.tempData);
      temp.push(this.tempdata2);
      temp.push(this.tempdata3);
      temp.push(this.tempdata4);
      temp.push(this.tempdata5);
      temp.push(this.tempdata6);
      temp.push(this.tempdata7);
      temp.push(this.tempdata8);
      temp.push(this.tempdata9);
      console.log("Final Save method", temp)
      let MolData: any= {
        "manual_data": temp
      }
      console.log("Save Edit", temp)
      this.userFormService.saveData(MolData).subscribe((res)=>{
        console.log("EDITED DATA", res)
        this.getUserFormTemplate();
      this.toastr.success('Data saved sucessfully', '');
      })
    }
   
  }
  
}
